<template>
    <d-card class="mt-3 mb-3" sm="12">
        <modal :adaptive="true" height="auto" name="request">
            <d-row>
                <d-col lg="12">
                    <d-card class="card-small card-post">
                        <d-card-body>
                            <h6>Edit Account</h6>
                            <d-row class="d-flex justify-content-center">
                                <d-col lg="12">
                                    <d-form id="networkForm" @submit.prevent="editNetwork">
                                        <d-form-row class="mt-3" v-if="update.affiliateNetwork">
                                            <d-col
                                                v-if="update.affiliateNetwork.config.has_resellers"
                                                class="form-group"
                                                md="12"
                                            >
                                                <label for="label">
                                                    Account name:
                                                </label>
                                                <d-form-input
                                                    v-model="update.form.accountName"
                                                    type="text"
                                                    id="label"
                                                />
                                            </d-col>
                                            <d-col
                                                v-if="update.affiliateNetwork.config.has_resellers"
                                                class="form-group"
                                                md="12"
                                            >
                                                <label for="label">
                                                    Account color:
                                                </label>
                                                <b-form-input
                                                    id="type-color"
                                                    type="color"
                                                    v-model="update.form.accountColor"
                                                >
                                                </b-form-input>
                                            </d-col>
                                            <d-col
                                                v-for="credentialsField in update.affiliateNetwork.config.credentials_fields"
                                                md="12"
                                                class="form-group"
                                            >
                                                <label :for="credentialsField.name">
                                                    {{ credentialsField.title }}
                                                </label>
                                                <d-form-input
                                                    v-model="update.form.credentials[credentialsField.name]"
                                                    :type="credentialsField.type"
                                                    :id="credentialsField.name"
                                                />
                                            </d-col>
                                            <d-col v-if="update.affiliateNetwork.config.multicurrency_per_media" md="12" class="form-group">
                                                <label for="currency">Currency:</label>
                                                <d-form-select v-model="update.form.currency">
                                                    <option v-for="currency in currencies" :value="currency.code">{{ currency.name }}</option>
                                                </d-form-select>
                                            </d-col>
                                            <d-col md="12" class="form-group d-flex justify-content-end">
                                                <button type="button" @click="hideModal" class="btn btn-secondary mr-3">Cancel</button>
                                                <input value="Done" type="submit" class="btn btn-success">
                                            </d-col>
                                        </d-form-row>
                                    </d-form>
                                </d-col>
                            </d-row>
                        </d-card-body>
                    </d-card>
                </d-col>
            </d-row>
        </modal>
        <network-programs-list-modal/>
        <d-card-header class="pb-0 mb-3">Connected networks</d-card-header>
        <d-card-body class="p-0">
            <v-client-table class="dataTables_wrapper domain-table" :data="networks" :columns="columns" :options="clientTableOptions">
                <d-col slot="logo" slot-scope="props" size="small" class="sc-stats__image mx-auto">
                    <d-col class="rounded-circle" v-bind:style="{ backgroundColor: props.row.affiliateNetwork.color }">
                        <span class="letter-icon">{{ props.row.affiliateNetwork.short_name | firstLettersLimit }}</span>
                    </d-col>
                </d-col>
                <d-col slot="network" slot-scope="props" size="small">
                    <span>
                        {{ props.row.affiliateNetwork.human_readable_name }}
                    </span>
                </d-col>
                <d-col slot="transaction" slot-scope="props" size="small">
                    <span v-if="props.row.lastTransactions[0]">
                        {{ props.row.lastTransactions[0].date_transaction }}
                    </span>
                </d-col>
                <d-col slot="status" slot-scope="props" size="small">
                    <d-badge pill class="badge badge-primary badge-pill badge-success">
                        Connected
                    </d-badge>
                </d-col>
                <d-col slot="program_settings" slot-scope="props" size="small">
                    <button type="button" @click="showProgramSettingsModal(props.row)" class="btn btn-success">Configure</button>
                </d-col>
                <d-col v-if="props.row.affiliateNetwork.type == 'postback'" slot="buttons" class="buttons" slot-scope="props" size="small">
                    <template v-if="checkPermission(permissionTypes.mediaWrite)">
                        <confirm-message
                            :message="`You are about to delete your connection with ${props.row.affiliateNetwork.human_readable_name}.`"
                            :keep-button-text="`No, keep ${props.row.affiliateNetwork.human_readable_name}`"
                            @confirm="deleteNetwork(props.row.id)"
                        >
                            <i class="fas fa-trash ml-2" />
                        </confirm-message>
                    </template>
                </d-col>
                <d-col v-else slot="buttons" class="buttons" slot-scope="props" size="small">
                    <template v-if="checkPermission(permissionTypes.mediaWrite)">
                    <i
                        v-if="props.row.affiliateNetwork.type !== 'daisycon-oauth'"
                        @click="showModal(
                            props.row.id,
                            props.row.affiliateNetwork.name,
                            props.row.currency_code,
                            JSON.parse(props.row.credentials),
                            props.row.name,
                            props.row.color
                        )"
                        class="fa fa-pencil"
                    />
                    <i
                        v-if="props.row.affiliateNetwork.type == 'daisycon-oauth'"
                        class="fa fa-pencil"
                        @click="redirectToUpdateConnection(props.row.affiliateNetwork.id, props.row.id)"
                    />
                    <confirm-message
                        class="d-inline-block cursor-pointer"
                        :message="`You are about to delete your connection with ${props.row.affiliateNetwork.human_readable_name}.`"
                        :keep-button-text="`No, keep ${props.row.affiliateNetwork.human_readable_name}`"
                        @confirm="deleteNetwork(props.row.id)"
                    >
                        <i class="fas fa-trash ml-2 cursor-pointer" />
                    </confirm-message>
                    </template>
                </d-col>
            </v-client-table>
        </d-card-body>
        <d-card-footer v-if="checkPermission(permissionTypes.mediaWrite)" class="d-flex justify-content-end">
            <d-link tag="button" :to="{ name: 'connect-network' }" class="btn mb-2 mr-1 btn-success"><i class="fas fa-plus"></i>  Connect new network</d-link>
        </d-card-footer>
    </d-card>
</template>

<script>
    import { WebsiteService, AffiliateNetworkService, ErrorService } from '@/main';
    import currency from '@/mixins/currency';
    import notification from '@/mixins/notification';
    import Status from '@/helpers/status';
    import NetworkStatus from '@/helpers/networkStatus';
    import ConfirmMessage from '@/components/common/confirmMessage.vue';
    import NetworkProgramsListModal from '@/components/network/NetworkProgramsListModal.vue';
    import permissions from '../../mixins/permissions';

    export default {
        mixins: [notification, currency, permissions],
        components: {
            ConfirmMessage,
            NetworkProgramsListModal
        },

        data() {
            return {
                affiliateNetworks: [],
                update: {
                    accountId: null,
                    affiliateNetwork: null,
                    form: {
                        accountName: '',
                        accountColor: '',
                        credentials: null,
                        currency: '',
                    },
                },
                mediaIds: [],
                networks: [],
                columns: ['logo', 'network', 'transaction', 'status', 'program_settings', 'buttons'],
                /**
                 * Vue Tables Configuration Options
                 * @see https://github.com/matfish2/vue-tables-2
                */
                clientTableOptions: {
                    perPage: 25,
                    pagination: { show: false },
                    childRowTogglerFirst: false,
                    recordsPerPage: [25, 50, 100],
                    skin: 'transaction-history table dataTable',
                    filterable: false,
                    texts: {
                        limit: 'Show',
                        count: ''
                    },
                    columnsDisplay: {
                        status: 'desktop',
                        transaction: 'desktop',
                        connected: 'desktop',
                        configured: 'desktop',
                    },
                    columnsClasses: {
                        network: 'network-table',
                        transaction: 'network-table',
                        integration: 'network-table',
                        connected: 'network-table',
                        configured: 'network-table',
                    },
                    headings: {
                        logo: '',
                        network: 'Network',
                        created_at: 'Connected on',
                        transaction: 'Last transaction',
                        status: 'Status',
                        buttons: '',
                        integration: 'Integration',
                        goal_name: 'Configured with',
                    },
                },
            };
        },

        methods: {
            redirectToUpdateConnection(affiliateNetworkId, accountId) {
                this.$router.push({ name: 'network-update', params: {
                    websiteId: this.$route.params.id,
                    networkId: affiliateNetworkId,
                    accountId: accountId
                }})
            },

            getErrorMessage(e) {
                if (e.extensions.validation) {
                    return e.extensions.validation.network_id[0]
                } else {
                    return e.message
                }
            },

            getStatus(status) {
                return NetworkStatus.getStatusClass(status);
            },

            showModal(accountId, networkName, currency, credentials, accountName, accountColor) {
                this.update.accountId = accountId
                this.update.affiliateNetwork = this.findAffiliateNetwork(networkName)
                this.update.form.currency = currency;
                this.update.form.credentials = credentials
                this.update.form.accountName = accountName
                this.update.form.accountColor = accountColor

                this.$modal.show('request');
            },

            hideModal() {
                this.$modal.hide('request');
            },

            showProgramSettingsModal(account) {
              this.$modal.show('network_programs', { affiliateNetworkAccount: account });
            },

            async editNetwork() {
                try {
                    await AffiliateNetworkService.update(
                        this.update.form.credentials,
                        this.update.accountId,
                        this.update.affiliateNetwork.name,
                        this.update.affiliateNetwork.id,
                        this.update.form.currency,
                        this.$route.params.id,
                        this.update.form.accountName,
                        this.update.form.accountColor
                    )
                    this.showNotification('success', 'Alert', 'Network successfully edited!')
                    this.hideModal()
                    this.$router.go()
                } catch(e) {
                    this.showNotification('error-notification', 'Oops! we have a problem', ErrorService.getErrorMessage(e.networkError.result.errors[0]))
                    console.log(e)
                }
            },

            async getMediaIds() {
                try {
                    this.mediaIds = await AffiliateNetworkService.getMediaIds(this.$route.params.id)
                    this.getNetworks()
                } catch (e) {
                    this.showNotification('warn', 'We have a problem', 'Oops! can not get medias')
                    console.log(e)
                }
            },

            async getNetworks() {
                try {
                    this.networks = await AffiliateNetworkService.getNetworks(this.$route.params.id, this.mediaIds)
                    this.networks.forEach((network) => {
                      network.affiliateNetworkProgramAnalyticsEvents.forEach((analyticEvent) => {
                        this.$store.commit('gaEventTypesStore/addEventType', analyticEvent.event_name)
                      })
                    })
                } catch (e) {
                    this.showNotification('warn', 'We have a problem', 'Oops! can not get affiliates')
                    console.log(e)
                }
            },

            async deleteNetwork(accountId) {
                try {
                    await AffiliateNetworkService.delete(this.$route.params.id, accountId)
                    this.showNotification('success', 'Alert', 'Network successfully removed!')
                    this.$router.go()
                } catch (e) {
                    this.showNotification('warn', 'We have a problem', 'Oops! something went wrong')
                    console.log(e)
                }
            },

            async getAffiliates() {
                try {
                    this.affiliateNetworks = await AffiliateNetworkService.getByStatusId(1)
                } catch (error) {
                    this.showNotification('warn', 'We have a problem', 'Oops! can not get affiliates')
                    console.log(error)
                }
            },

            findAffiliateNetwork(name) {
                return this.affiliateNetworks.find(affiliateNetwork => affiliateNetwork.name === name)
            },
        },

        created() {
            this.getMediaIds()
            this.getAffiliates()
        },

        watch: {
            $route(to, from) {
                this.getMediaIds()
                this.getAffiliates()
            }
        },
    };
</script>

<style scoped>
#type-color {
    height: 65%;
}
</style>
